import React from 'react';
import { Route, Routes } from 'react-router';
import Anexar from './Anexar';
import Cte from './Cte';
import Main from './Main';
import Options from './Options';
import Recibo from './Recibo';
import Romaneio from './Romaneio';
import Servico from './Servico';

const FreightControl: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Main/>}/>
            <Route path="/opcoes" element={<Options/>}/>
            <Route path="/cte" element={<Cte/>}/>
            <Route path="/servico" element={<Servico/>}/>
            <Route path="/romaneio" element={<Romaneio/>}/>
            <Route path="/recibo" element={<Recibo/>}/>
            <Route path="/anexar" element={<Anexar/>}/>
            <Route path="/anexar/:tipo/:pktransportadora/:pk" element={<Anexar/>}/>
            <Route path="/anexar/:tipo/:pktransportadora/:pk/:page" element={<Anexar/>}/>
            <Route path="/editar/1/:pktransportadora/:pk" element={<Cte/>}/>
            <Route path="/editar/2/:pktransportadora/:pk" element={<Romaneio/>}/>
            <Route path="/editar/3/:pktransportadora/:pk" element={<Servico/>}/>
            <Route path="/editar/4/:pktransportadora/:pk" element={<Recibo/>}/>
        </Routes>
    )
}

export default FreightControl;